var UTIL = {
	fire: function(element, name, data) {
		var event = null;
		if (window.CustomEvent) {
			event = new CustomEvent(name, {detail: data});
		} else {
			event = document.createEvent('CustomEvent');
			event.initCustomEvent(name, true, true, data);
		}

		element.dispatchEvent(event);
	},

	toggleClass: function (element, className) {
		if (element.classList.contains(className)) {
			element.classList.remove(className);
		} else {
			element.classList.add(className);
		}
	}
};

var body = document.getElementsByTagName('body')[0];
var navToggle = document.getElementsByClassName('nav-toggle');

var navToggleFunc = function() {
	UTIL.toggleClass(this, 'navigation-open');
};

for (var i = 0; i < navToggle.length; i++) {
	navToggle[i].addEventListener('click', navToggleFunc.bind(body));
}


function togglePlayingClass() {
	UTIL.toggleClass(this, 'playing');
	this.removeEventListener('click', togglePlayingClass, false );
}

var fullSizeVideoWrappers = document.querySelectorAll('.full-size-element.video');
for (var j = 0; j < fullSizeVideoWrappers.length; j++) {
	var videoWrap = fullSizeVideoWrappers[j];
	var video = videoWrap.getElementsByTagName('video')[0];

	videoWrap.addEventListener('click', function () {
		var video = this.getElementsByTagName('video')[0];
		if (video.paused) {
			video.play();
			video.controls = true;
		}
	}.bind(videoWrap));

	video.addEventListener('pause', togglePlayingClass.bind(videoWrap));
	video.addEventListener('play', togglePlayingClass.bind(videoWrap));
}

(function($) {
	setTimeout(function () {
		$('.cd-image-container').imagesCompare();
	}, 750);

	var slider = $('.Slider').flickity({
		// options
		cellAlign: 'left',
		cellSelector: '.Slider--Item',
		pageDots: true,
		contain: true,
		arrowShape: ''
	});

	slider.on( 'staticClick.flickity', function( event, pointer, cellElement, cellIndex ) {
		if ( typeof(cellIndex) === 'number' ) {
			slider.flickity( 'selectCell', cellIndex );
		}
	});


	$('.Masonry').masonryFilter({
		itemWrapperSelector: '.Masonry-ItemWrapper',
		itemSelector: '.Masonry-SingleItem'
	});

	$(window).one('scroll', function () {
		var scrollInfo = $('.ScrollInfo');
		scrollInfo.addClass('ScrollInfo--scrolled');

		setTimeout(function () {
			scrollInfo.hide();
		}, 700);
	});

})(jQuery);
